<template>
  <div id="paginaAttivitaBanco">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoAttivitaBanco -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Attivita Banco</b-card-title>
              <b-card-text class="mb-0"> Centro Componenti TV </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item href="#"> ... </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid
                  id="gridA"
                  ref="gridA"
                  :dataSource="attivitaBancoFullData"
                  :allowSorting="true"
                  :sortSettings="gridA.sortOptions"
                  :toolbarClick="gridAClickHandler"
                  :toolbar="gridA.toolbarOptions"
                  :height="gridA.height"
                  :allowFiltering="true"
                  :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin"
                  :actionComplete="gridAactionComplete"
                >
                  <e-columns>
                    <e-column
                      field="id"
                      headerText="ID"
                      :isPrimaryKey="true"
                      width="60"
                    ></e-column>
                    <e-column
                      field="data"
                      headerText="Data"
                      width="150"
                      type="date"
                      :format="settings.formatoData"
                    ></e-column>
                    <e-column
                      field="account"
                      headerText="Account"
                      width="150"
                    ></e-column>
                    <e-column
                      field="cliente"
                      headerText="Cliente"
                      width="200"
                    ></e-column>
                    <e-column
                      field="tipologiaAttivitaBanco"
                      headerText="Codice Tip. Attività Banco"
                      width="250"
                      foreignKeyField="id"
                      foreignKeyValue="codice"
                      :dataSource="this.elencoTipologieAttivitaBancoList"
                    ></e-column>
                    <e-column
                      field="tipologiaAttivitaBanco"
                      headerText="Descr. Tip. Attività Banco"
                      width="300"
                      foreignKeyField="id"
                      foreignKeyValue="descrizione"
                      :dataSource="this.elencoTipologieAttivitaBancoList"
                    ></e-column>
                    <e-column
                      field="negozio"
                      headerText="Negozio"
                      width="200"
                      foreignKeyField="id"
                      foreignKeyValue="codiceNegozio"
                      :dataSource="this.elencoNegoziList"
                    ></e-column>
                    <e-column
                      field="addetto"
                      headerText="Addetto"
                      width="200"
                      foreignKeyField="id"
                      foreignKeyValue="cognome"
                      :dataSource="this.elencoAddettiList"
                    ></e-column>
                    <e-column
                      field="conferma"
                      headerText="Conferma"
                      width="200"
                      foreignKeyField="val"
                      foreignKeyValue="label"
                      :dataSource="this.confermaList"
                    ></e-column>
                    <e-column
                      field="venditaParcoAbbinata"
                      headerText="Vendita Parco Abbinata"
                      width="250"
                    ></e-column>
                    <e-column
                      field="note"
                      headerText="Note"
                      width="400"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioAttivitaBanco ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA"
      ref="dialogA"
      :header="dialogA.header"
      :buttons="dialogA.buttons"
      :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon"
      :close="dialogAClose"
      :open="dialogAOpen"
      :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings"
      :isModal="dialogA.isModal"
      v-on:submit.prevent="noop"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Informazioni AttivitaBanco" @click="tabClicked('dialogATab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: anagrafica -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Attività Banco</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo: attivitaBancoActiveData.id  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox
                        id="id"
                        v-model="attivitaBancoActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="id"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: attivitaBancoActiveData.data  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker
                        id="data"
                        v-model="attivitaBancoActiveData.data"
                        :format="settings.formatoDatepicker"
                        placeholder="Data"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo testo: attivitaBancoActiveData.account  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="account" class="h5">Account</label>
                      <ejs-textbox
                        id="account"
                        v-model="attivitaBancoActiveData.account"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Account"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: attivitaBancoActiveData.cliente  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="cliente" class="h5">Cliente</label>
                      <ejs-textbox
                        id="cliente"
                        v-model="attivitaBancoActiveData.cliente"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Cliente"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni con template: attivitaBancoActiveData.tipologiaAttivitaBanco  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologiaAttivitaBanco" class="h5"
                        >Tipologia Attività Banco</label
                      >
                      <ejs-dropdownlist
                        id="tipologiaAttivitaBanco"
                        v-model="attivitaBancoActiveData.tipologiaAttivitaBanco"
                        :dataSource="elencoTipologieAttivitaBancoList"
                        :fields="elencoTipologieAttivitaBancoFields"
                        placeholder="Selezione Tipologia Attività Banco"
                        :itemTemplate="tipologiaAttivitaBancoITempl"
                        :valueTemplate="tipologiaAttivitaBancoVTempl"
                        :change="onTipologiaAttivitaBancoChange"
                        sortOrder="Ascending"
                        allowFiltering="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni senza template: attivitaBancoActiveData.negozio  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="negozio" class="h5"
                        >Negozio</label
                      >
                      <ejs-dropdownlist
                        id="negozio"
                        v-model="attivitaBancoActiveData.negozio"
                        :dataSource="elencoNegoziList"
                        :fields="elencoNegoziFields"
                        placeholder="Selezione Negozio"
                        showClearButton="true"
                        sortOrder="Ascending"
                        allowFiltering="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni senza template: attivitaBancoActiveData.addetto  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                    >
                      <label for="addetto" class="h5"
                        >Addetto</label
                      >
                      <ejs-dropdownlist
                        id="addetto"
                        v-model="attivitaBancoActiveData.addetto"
                        :dataSource="elencoAddettiList"
                        :fields="elencoAddettiFields"
                        placeholder="Selezione Addetto"
                        showClearButton="true"
                        sortOrder="Ascending"
                        allowFiltering="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni senza template: attivitaBancoActiveData.conferma  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showConferma"
                    >
                      <label for="conferma" class="h5"
                        >Conferma</label
                      >
                      <ejs-dropdownlist
                        id="conferma"
                        v-model="attivitaBancoActiveData.conferma"
                        :dataSource="confermaList"
                        :fields="labelValFields"
                        placeholder="Selezione Stato Conferma"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: attivitaBancoActiveData.venditaParcoAbbinata  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="venditaParcoAbbinata" class="h5">Vendita Parco Abbinata</label>
                      <ejs-textbox
                        id="venditaParcoAbbinata"
                        v-model="attivitaBancoActiveData.venditaParcoAbbinata"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Vendita Parco Abbinata"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: attivitaBancoActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="attivitaBancoActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="3"
                      />
                    </b-col>

                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormCheckboxPlugin,
  FormSelectPlugin,
  FormRatingPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
// import {
//   extend, addClass, createElement, isNullOrUndefined, detach, EventHandler,
// } from '@syncfusion/ej2-base'
import {
  DateTimePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
  CalendarPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  ListBoxPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormRatingPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(ListBoxPlugin);
Vue.use(CalendarPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apiAttivitaBancoUrl = "/main/api/attivitaBanco";
const apiTipologieAttivitaBancoUrl = "/main/api/tipologiaAttivitaBanco";
const apiNegoziUrl = "/main/api/negozio";
const apiVenditoriUrl = "/main/api/venditore";

// personalizzo la visualizzazione della tendina visualizzata dal dropdown tipologiaAttivitaBanco
var tipologiaAttivitaBancoITVue = Vue.component("tipologiaAttivitaBancoITempl", {
  template: `<span><span class='nonDefinita'>{{data.codice}}</span>&nbsp<span class ='nonDefinita'>{{data.descrizione}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

// personalizzo la visualizzazione del valore visualizzato dal dropdown tipologiaAttivitaBanco
var tipologiaAttivitaBancoVTVue = Vue.component("tipologiaAttivitaBancoVTempl", {
  template: `<span><span class='nonDefinita'>{{data.codice}}</span>&nbsp<span class ='nonDefinita'>{{data.descrizione}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      // spinner
      loading: false,
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      showConferma: false,
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        formatoOra: "HH:mm",
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // struttura etichetta - valore per dropdown
      labelValFields: { value: "val", text: "label" },
      // soggetti
      attivitaBancoFullData: [], // elenco completo dati Attivita Banco
      attivitaBancoActiveId: 0, // Id AttivitaBanco attivo (0 se nuovo)
      attivitaBancoActiveData: {}, // dati completi della AttivitaBanco attivo
      attivitaBancoSavedData: {}, // dati completi della AttivitaBanco attivo
      attivitaBancoDefaultData: {}, // dati completi di default per nuove Attivita Banco

      // per conferma
      confermaList:[
        { label: "Confermato", val: "confermato" },
        { label: "Non Confermato", val: "nonConfermato" },
      ],

      // per gestione elenco tipologie AttivitaBanco
      elencoTipologieAttivitaBancoList: [],
      elencoTipologieAttivitaBancoFields: { value: "id", text: "codice" },

      // per gestione elenco Negozi
      elencoNegoziList: [],
      elencoNegoziFields: { value: "id", text: "citta" },

      // per gestione elenco Addetti
      elencoAddettiList: [],
      elencoAddettiFields: { value: "id", text: "cognome" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuova attività banco",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Apri",
            tooltipText: "Modifica attività banco",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella attività banco",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "id", direction: "Ascending" }] },
      },
      // per itemtemplate
      tipologiaAttivitaBancoITempl: function () {
        return { template: tipologiaAttivitaBancoITVue };
      },
      tipologiaAttivitaBancoVTempl: function () {
        return { template: tipologiaAttivitaBancoVTVue };
      },
    };
  },
  created() {
    console.log("Pagina Attivita Banco Creata");
    this.loading = true;
    console.log(this.loading);
    console.log("Recupero elenchi dal backend");
    // tipologieAttivitaBanco
    useJwt.get(apiTipologieAttivitaBancoUrl).then((d) => {
      console.log("Elenco Tipologie AttivitaBanco");
      console.log(d.data);
      this.elencoTipologieAttivitaBancoList = d.data;
    });
    // negozi
    useJwt.get(apiNegoziUrl).then((d) => {
      console.log("Elenco Negozi");
      console.log(d.data);
      this.elencoNegoziList = d.data;
    });
    // Addetti
    useJwt.get(apiVenditoriUrl).then((d) => {
      console.log("Elenco Venditori");
      console.log(d.data);
      this.elencoAddettiList = d.data;
      // filtro in base a tipologia venditore
      const results = this.elencoAddettiList.filter((obj) => {
        return obj.tipologia === "addetto";
      });
      console.log("Elenco Addetti");
      console.log(results);
      this.elencoAddettiList = results;
    });
    // attivitaBancoFullData
    // recupero elenco Attivita Banco dal backend
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco Attivita Banco dal backend");
      useJwt.get(apiAttivitaBancoUrl).then((d) => {
        console.log("Attivita Banco");
        console.log(d.data);
        this.attivitaBancoFullData = d.data;
        this.loading = false;
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente

    // attivitaBancoDefaultData ( esplicitato nei pulsanti "Nuovo.." della gridA )
    this.attivitaBancoDefaultData = {};
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per listBox
    listbox: [CheckBoxSelection],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("Attività banco attiva");
      console.log(this.attivitaBancoActiveId);
      console.log(this.attivitaBancoActiveData);
      this.attivitaBancoSavedData = { ...this.attivitaBancoActiveData };
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
      // inizializza la visibilità dei campi in base ai dati presenti in TipologieAttivitaBanco
      if (this.attivitaBancoActiveId != 0) {
        // recupero i dati della configurazione di tipologie di AttivitaBanco corrente da elencoTipologieAttivitaBancoList
        var arrayToSearch = this.elencoTipologieAttivitaBancoList;
        var itemToFind = this.attivitaBancoActiveData.tipologiaAttivitaBanco;
        var tipologiaAttivitaBancoData = arrayToSearch.find(
          (item) => item.id === itemToFind
        );
        console.log(tipologiaAttivitaBancoData);
        this.showConferma =
          tipologiaAttivitaBancoData.necessitaConferma;
      }
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      console.log(this.attivitaBancoActiveData);
    },
    dialogAOk() {
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.attivitaBancoActiveId === 0) {
        // salvataggio in caso di new
        console.log(this.attivitaBancoActiveData);
        useJwt
          .post(apiAttivitaBancoUrl, this.attivitaBancoActiveData)
          .then((res) => {
            //console.log(res.status);
            this.attivitaBancoActiveId = res.data.id;
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            useJwt.get(apiAttivitaBancoUrl).then((res) => {
              console.log("Aggiornamento gridA con l'aggiunta di una attività banco");
              context.attivitaBancoFullData = res.data;
              context.attivitaBancoFullData = [...context.attivitaBancoFullData];
              console.log(res.data);
            });
            // nascondi dialog solo se creazione avvenuta con successo
            context.$refs.dialogA.hide();
          })
          .catch((error) => {
            // costruzione messaggio di errore da mostrare
            const obj = JSON.parse(error.response.request.response);
            const message = Object.keys(obj)[0] + ": " + Object.values(obj)[0];
            this.makeToast("primary", "ERRORE", message);
            console.log(Object.keys(obj)[0]);
            console.log(Object.values(obj)[0]);
          });
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiAttivitaBancoUrl}/${this.attivitaBancoActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt
          .patch(editUrl, this.attivitaBancoActiveData)
          .then((res) => {
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            useJwt.get(apiAttivitaBancoUrl).then((res) => {
              console.log("Aggiornamento gridA con la modifica di una attività banco");
              context.attivitaBancoFullData = res.data;
              context.attivitaBancoFullData = [...context.attivitaBancoFullData];
            });
            // nascondi dialog solo se creazione avvenuta con successo
            context.$refs.dialogA.hide();
          })
          .catch((error) => {
            // costruzione messaggio di errore da mostrare
            // TODO: possibili errori multipli
            const obj = JSON.parse(error.response.request.response);
            const message = Object.keys(obj)[0] + ": " + Object.values(obj)[0];
            this.makeToast("primary", "ERRORE", message);
            //console.log(error.response.data.message || error.message)
            console.log(Object.keys(obj)[0]);
            console.log(Object.values(obj)[0]);
          });
      }
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova attività banco";
        this.attivitaBancoDefaultData = {
          id: 0,
          data: null,
          cliente: null,
          negozio: null,
          addetto: null,
          tipologiaAttivitaBanco: null,
          conferma: null,
          venditaParcoAbbinata: null,
        };
        this.attivitaBancoActiveData = this.attivitaBancoDefaultData;
        console.log("Premuto pulsante creazione nuova attività banco da gridA");
        this.attivitaBancoActiveId = 0;
        // inizializzo
        this.showConferma = false;
        this.$refs.dialogA.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica attività banco da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.attivitaBancoActiveId = selectedRow[0].id;
          console.log(this.attivitaBancoActiveId);
          for (const i in this.attivitaBancoFullData) {
            if (this.attivitaBancoFullData[i].id === this.attivitaBancoActiveId) {
              this.attivitaBancoActiveData = { ...this.attivitaBancoFullData[i] };
              found = true;
              break;
            }
          }
          console.log("ATTIVITA' BANCO CORRENTE");
          console.log(this.attivitaBancoActiveData);
          console.log(this.attivitaBancoActiveId);

          if (found) {
            console.log("Edit attività banco");
            this.dialogA.header = "attività banco";
            this.$refs.dialogA.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina attività banco da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiAttivitaBancoUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiAttivitaBancoUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio attività banco non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
    },
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogATab01":
          console.log("Sei nel primo tab del dialogA");
          break;
        case "dialogATab02":
          console.log("Sei nel secondo tab del dialogA");
          break;
        default:
          console.log(args);
      }
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
    // per aggiornamento tipologia di attività banco
    onTipologiaAttivitaBancoChange: function (e) {
      if (this.attivitaBancoActiveData.tipologiaAttivitaBanco) {
        console.log("Tipologia di attività banco Corrente:");
        console.log(this.attivitaBancoActiveData.tipologiaAttivitaBanco);
        // recupero i dati della configurazione di tipologie di attività banco corrente da elencoTipologieAttivitaBancoList
        var arrayToSearch = this.elencoTipologieAttivitaBancoList;
        var itemToFind = this.attivitaBancoActiveData.tipologiaAttivitaBanco;
        var tipologiaAttivitaBancoData = arrayToSearch.find(
          (item) => item.id === itemToFind
        );
        console.log(tipologiaAttivitaBancoData);
        this.showConferma =
          tipologiaAttivitaBancoData.necessitaConferma;
      }
    },
  },
  computed: {},
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import "~@syncfusion/ej2-schedule/styles/material.css";
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}
</style>
